import { ESetupType, PanelDataProps } from "./common/commontypes"

import { EToothDirection } from "./modules/toothmanager/toothdirection"
import {
  IAttachmentIPRVisible,
  IAuxullartiesShowInfo,
  ReportAttachmentData,
  ReportAttachmentFirstStageData,
  ReportAttachmentToothListData,
} from "./modules/attachment/attachmentModule"
import {
  CaseZipType,
  ICaseExtInfo,
  ICaseExtraAttr,
  ZipFileName,
  ZipFileList,
} from "./common/types"
import { ReportIPRData } from "./modules/ipr/iprModule"
import { TypeInNumber, IToothProperty } from "./modules/toothmanager"
import { IWASMBoltonReport } from "./modules/bolton"
import { EArchTreatmentType } from "./modules/preview/preview"
import { JointStageData } from "./modules/stagingdatamanager/stagingmanager"

export enum EBiteJumpLocationType {
  EBiteJumpLocation_Off = 0,
  EBiteJumpLocation_Start = 1,
  EBiteJumpLocation_All = 2,
  EBiteJumpLocation_End = 3,
}

export interface IPresetupOptions {
  upperArch: Blob
  lowerArch: Blob
  canvas: HTMLCanvasElement
  donecallback: () => void
}

export interface HoverToothData {
  isShow: boolean
  toothid: number
  isUpper: boolean
  position: [number, number]
  hoverString: string
  properties: {
    isCrown: boolean
    isImplant: boolean
    isBridge: boolean
    isPontic: boolean
    isPrimary: boolean
    isErupting: boolean
  }
}




/**
 *  STLModel Preview of Uploading & Fillinghole
 */
export interface IDrawSTLOps {
  upperArch: File | null
  lowerArch: File | null
  canvas: HTMLCanvasElement
  zoomRange: [number, number]
  fillholeCallback?: (isSuccess: boolean, errmsg: string) => void
  onZoomChange?: (zoomScaleVal: number) => void
  isShowRefinement?: boolean
}

/**
 *the options of drawRefinementSTL
 */
export interface IDrawRefinementSTLOps {
  upperArch: File | null
  lowerArch: File | null
  zoomRange: [number, number]
}


/**
 * Interfaces of Stage controling
 */
export interface IStageControl {
  /**
   * get wasm stage data
   * @returns
   */
  getWasmStageData: () => JointStageData
  /**
   * set stage value from UI
   * @param upstep
   * @param lowstep
   */
  setStageStep: (upstep: number, lowstep: number) => void

  /**
   * give notice to UI when current stage number change
   * @param arch
   * @param index
   */
  setStageCallback: (callback: (wasmStageData) => void) => void
  /**
   * give notice to UI when Setup Type
   * @param callback
   * @returns
   */
  setSetupTypeCaseCallback: (
    callback: (type: ESetupType, ndoeIndex: number) => void,
  ) => void

  /**
   * get count of KeyPoints ,return which is larger between upper and lower.
   * if the max number is 8,It means there are 9 steps
   * @returns
   */
  getMaxStageNodeIndex: () => number

  /**
   * get the current stage index
   * @returns
   */
  getCurrentStageIndex: () => { upper: number; lower: number }

  /**
   * switch step between Initial and current
   */
  switchIC: () => void

  /**
   * set BiteJump Type
   * @param biteJumpType
   * @returns
   */
  setBiteJumpType: (biteJumpType: EBiteJumpLocationType) => void

  /**
   * 获取下颌是否做过bite jump
   * @returns
   */
  isDownArchBiteMoved: () => boolean

  /**
   * play GM animation
   * @returns
   */
  playGMAnimation: () => number

  /**
   * set biteJump type and play GM
   * @param biteJumpType
   * @returns
   */
  setBiteJumpTypePlayGM: (biteJumpType: EBiteJumpLocationType) => void

  /**
   * get biteJump type
   * @returns
   */
  getBiteJumpType: () => number
  /**
   * add more stage
   * @param archType 0, 1
   * @param addMore true, false
   * @returns 
   */
  SetAddMoreFoFinalStage: (archType: number, addMore: boolean) => void
}

/**
 * Interfaces of Initial-final
 */
export interface IInitialFinal {
  /**
   * 打开或者关闭initialfinal窗口
   * @param isEnable
   */
  setInitialFinalEnabled: (isEnabled: boolean) => void

  /**
   * 前端传入的zoom缩放值
   * @param scaleFac
   * @returns
   */
  zoomByScale: (scaleFac: number) => void

  /**
   * 鼠标滚轮滑动时回调给前端当前的zoom缩放值(每次重新打开initialfinal模块都需要调用)
   * @param callback
   * @returns
   */
  setZoomInitialFinalCallback: (callback: (value: number) => void) => void

  /**
   * 当打开initialfinal窗口后再点击occlusal按钮后调用
   * @returns
   */
  openOcclusalView: () => void
}





